var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.48 7.88C13.48 10.9728 10.9728 13.48 7.88001 13.48C4.78721 13.48 2.28 10.9728 2.28 7.88C2.28 4.7872 4.78721 2.28 7.88001 2.28C10.9728 2.28 13.48 4.7872 13.48 7.88ZM12.2714 13.1765C11.0799 14.1654 9.54941 14.76 7.88001 14.76C4.08029 14.76 1 11.6797 1 7.88C1 4.08028 4.08029 1 7.88001 1C11.6797 1 14.76 4.08028 14.76 7.88C14.76 9.54941 14.1654 11.0799 13.1765 12.2714L16.8125 15.9075C17.0625 16.1574 17.0625 16.5626 16.8125 16.8125C16.5626 17.0625 16.1574 17.0625 15.9075 16.8125L12.2714 13.1765Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dc31807007dc1b8d8ceb7f0b73ee8456.svg";
export { ForwardRef as ReactComponent };